import { jsx as _jsx } from "react/jsx-runtime";
import { useIntl } from "react-intl";
import { Breadcrumbs } from "@material-ui/core";
import { ArrowForward } from "@material-ui/icons";
import { Link as RouterLink } from "react-router-dom";
import useBuyoutStyles from "../BuyoutStyles";
import { messages } from "../messages";
import clsx from "clsx";
import { formatApplicationNumber } from "../utils/formatApplicationNumber";
export default function BuyoutBreadcrumbs({ applicationNumber, application, includeContract = true }) {
    const classes = useBuyoutStyles();
    const intl = useIntl();
    const number = applicationNumber || application?.applicationNumber || "";
    const displayNumber = formatApplicationNumber(number);
    const crumbs = [
        {
            label: intl.formatMessage(messages.dashboard),
            to: "/dashboard"
        },
        {
            label: intl.formatMessage(messages.buyout),
            to: "/core-buyout"
        }
    ];
    if (includeContract) {
        crumbs.push({
            label: intl.formatMessage(messages.contract, { number: displayNumber }),
            to: `/core-buyout/${number}`
        });
    }
    return (_jsx(Breadcrumbs, { separator: _jsx(ArrowForward, { className: classes.breadcrumbsSeparator }), className: classes.breadcrumbs, children: crumbs.map((crumb, idx) => {
            const isLast = idx === crumbs.length - 1;
            return (_jsx(RouterLink, { to: crumb.to, className: clsx(classes.breadcrumb, isLast && classes.breadCrumbLast), children: crumb.label }, crumb.to));
        }) }));
}
//# sourceMappingURL=BuyoutBreadcrumbs.js.map